import { createRouteHandler } from '../../common';

export default createRouteHandler({
  includeSearch: true,
  includeFooter: false,
  importModule: () =>
    import(/* webpackChunkName: "chunk-manage-app-create" */ './ManageAppCreateRouteProcessor'),
});
